import { Col, Descriptions, Row } from 'antd'
import { FC } from 'react'
import _ from 'lodash'
import { useWatch } from 'antd/es/form/Form'
import { NamePath } from 'antd/es/form/interface'
import CalculationPosition from '../../../../../types/api/calculation-position'
import useFormInstance from 'antd/es/form/hooks/useFormInstance'
import formatIntegerBySpace from '../../../../../helpers/formatters/format-integer-by-space'

interface DescriptionOfCalculationPositionProps {
    name: NamePath
}

const DescriptionOfCalculationPosition: FC<DescriptionOfCalculationPositionProps> = ({ name }) => {
    const form = useFormInstance()
    const nameOfCalculationPosition = _.concat(['list', name], 'calculationPosition')
    const position: CalculationPosition =
        useWatch(nameOfCalculationPosition) || form.getFieldValue(nameOfCalculationPosition)

    const materialWidth = position.material?.width ?? position.calculated?.materialWidth ?? 0

    const machineNames = [
        ...(position.machine ? [position.machine.name.split(' ')[0]] : []),
        ...(position.additional_machines?.map(m => m.name.split(' ')[0]) ?? [])
    ].join(', ')


    return (
        <Row gutter={24}>
            <Col sm={12}>
                <Descriptions
                    styles={{ label: { width: 160 } }}
                    bordered
                    column={1}
                    size={'small'}
                    items={[
                        {
                            label: 'Штамп',
                            children: (
                                <>
                                    {position.withoutCutting ? "Без высечки" : `№ ${position.stamp?.number}`}, {position.withoutCutting ? position.virtualStamp?.width : position.stamp?.width} х{' '}
                                    {position.withoutCutting ? position.virtualStamp?.length : position.stamp?.length}
                                </>
                            ),
                        },
                        {
                            label: 'Ручьи',
                            children: <>{position.withoutCutting ? position.virtualStamp?.floods : position.stampFloods || position.stamp?.floods}</>,
                        },
                        {
                            label: 'Тираж',
                            children: <>{formatIntegerBySpace(position.copies)}</>,
                        }
                    ]}
                />
            </Col>
            <Col sm={12}>
                <Descriptions
                    styles={{ label: { width: 160 } }}
                    bordered
                    column={1}
                    size={'small'}
                    items={[
                        {
                            label: 'Ширина материала',
                            children: <>{materialWidth}</>,
                        },
                        {
                            label: 'Станок',
                            children: <><>{machineNames || '—'}</></>,
                        },
                    ]}
                />
            </Col>
        </Row>
    )
}

export default DescriptionOfCalculationPosition
